










































import Vue from 'vue';
import Component from 'vue-class-component';
import {
	mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import DatesForm from '@/components/DatesForm.vue';
import ErrorList from '@/components/ErrorList.vue';
import LoginModal from '@/components/LoginModal.vue';
import ReservationSidebar from '@/components/ReservationSidebar.vue';
import ReservationSteps from '@/components/ReservationSteps.vue';
import TransitionExpand from '@/components/TransitionExpand.vue';
import Customer from '@/models/Customer';
import Quote from '@/models/Quote';
import ReservationStep from '@/types/reservationStep';
import { getOr } from '@/utilities/helpers';
import moment from 'moment';

const Setup = Vue.extend({
	name: 'TheReservationBookPage',
	components: {
		ErrorList,
		DatesForm,
		LoginModal,
		ReservationSidebar,
		ReservationSteps,
		TransitionExpand,
	},
	computed: {
		...mapGetters(['loggedInCustomer', 'customer']),
		...mapState('reservation', ['reservation', 'step']),
		...mapState('location', ['locations']),
		...mapGetters('location', ['location', 'recurringLocations']),
	},
	props: {
		availableLocations: {} as () => Locations.Location[],
	},
	watch: {
		customer: {
			handler(value: Customer) {
				if (value.customer) {
					this.setCustomer(value);
					this.handleSubmittedDates();
				}
			},
		},
	},
	methods: {
		...mapMutations('reservation', ['clearQuote', 'setCustomer', 'setReservationSource', 'setStep']),
		...mapActions('reservation', ['getQuotes']),

		async handleSubmittedDates() {
			this.clearQuote();

			try {
				const response = await this.getQuotes();
			} catch (error) {
				// Error getting quotes.
			}
			this.setStep(ReservationStep.Quotes);
		},
	},
});

@Component
export default class TheReservationBookPage extends Setup {
	public Step = ReservationStep;

	// Vuex
	public clearQuote!: () => void;
	public customer!: Customer;
	public getQuotes!: () => Promise<Quote[]>;
	public location!: Locations.Location;
	public locations!: Locations.Location[];
	public setReservationSource!: (source: string) => void;
	public step!: ReservationStep;

	public get settings(): Locations.Settings {
		return this.$store.getters['location/settings'];
	}

	public get source(): string {
		return getOr('website', 'reservation.source', this.location);
	}

	public get shortcodeAttrs(): { [key: string]: string } {
		return this.$store.state.reservation.shortcodeAttrs;
	}

	public created() {
		this.$store.commit('preload', true);
		this.$store.commit('reservation/setLocation', this.location.code);

		// If a customer is signed in, add to the reservation.
		if (this.customer.customer) {
			this.setCustomer(this.customer);
		}

		this.setReservationSource(this.source);
		this.setTextOptIn();

		this.$store.subscribe((mutation: any) => {
			if (mutation.type === 'location/setLocation') {
				this.setReservationSource(this.source);
				this.$store.commit('reservation/setLocation', this.location.code);
				if (this.customer.customer) {
					this.setCustomer(this.customer);
				}

				if (this.step !== ReservationStep.Quotes) {
					this.setStep(ReservationStep.Dates);
				} else {
					this.getQuotes();
				}

				// If the location has reminder texts, update the text-opt-in.
				this.setTextOptIn();
			}
		});

		document.body.style.overflowY = 'scroll';
	}

	public get max_date(): number {
		let max = 2160; // 90 days
		if (this.settings) {
			max = +getOr(max, 'max_stay_length', this.settings);
		}
		return max / 24;
	}

	// Methods
	public setTextOptIn() {
		if (!this.location.settings) {
			return;
		}

		this.$store.commit('reservation/setTextOptIn', this.location.settings.has_reminder_texts);
	}
}
